import axios from "axios";
var $zipFields = document.querySelectorAll("[data-city-id]");

var zipToCity = {
  init: function() {
    $zipFields.forEach(($zipField) => {
      var country = "DK";
      var $countryField = document.getElementById(
        $zipField.getAttribute("data-country-id")
      );
      if ($countryField) {
        country = $countryField.value;
        $countryField.addEventListener("change", function(e) {
          country = $countryField.value;
        });
      }

      var $cityField = document.getElementById(
        $zipField.getAttribute("data-city-id")
      );

      if (country === "DK" && $zipField.value.length === 4) {
        updateCityFromZip($zipField.value, $zipField, $cityField);
      }

      var lastZip = "";

      $zipField.addEventListener("keyup", function(e) {
        if (
          country === "DK" &&
          $zipField.value.length === 4 &&
          $zipField.value !== lastZip
        ) {
          lastZip = $zipField.value;
          updateCityFromZip($zipField.value, $zipField, $cityField);
        }
      });
    });
  }
};

function updateCityFromZip(zip, $zipField, $cityField) {
  var timestamp = Date.now();
  axios
    .get("https://dawa.aws.dk/postnumre/autocomplete?nr=" + zip)
    .then((value) => {
      var timeDelta = Date.now() - timestamp;
      if (
        value.data[0] !== undefined &&
        value.data[0].postnummer !== undefined &&
        value.data[0].postnummer.navn !== undefined &&
        timeDelta < 1000
      ) {
        $cityField.value = value.data[0].postnummer.navn;
      }
    })
    .catch((error) => {
      console.error("zip-to-city lookup failed", error);
    });
}

export default zipToCity;
